import { useEffect, useMemo, useState } from 'react';
import { resolveLogoSrc } from '../../../utils/imageUtils';
import './TenantLogo.css';

type TenantLogoProps = {
  logo?: Blob | string | null;
  label: string;
  className?: string;
};

export function TenantLogo({ logo, label, className }: TenantLogoProps) {
  const [logoFailed, setLogoFailed] = useState(false);
  const { src: logoSrc, revokeUrl } = useMemo(
    () => resolveLogoSrc(logo),
    [logo],
  );

  useEffect(() => {
    // Reset load-error state when the src changes so a new logo can retry render.
    // eslint-disable-next-line react-hooks/set-state-in-effect -- sync derived UI flag to prop change
    setLogoFailed(false);
  }, [logoSrc]);

  useEffect(() => {
    if (revokeUrl == null) {
      return;
    }
    return () => {
      URL.revokeObjectURL(revokeUrl);
    };
  }, [revokeUrl]);

  const showLogo = logoSrc != null && !logoFailed;
  const initial = label.trim().slice(0, 1).toUpperCase() || '?';

  return (
    <span
      className={['tenant-logo', className].filter(Boolean).join(' ')}
      aria-hidden
    >
      {showLogo ? (
        <img
          className="tenant-logo__image"
          src={logoSrc}
          alt=""
          onError={() => setLogoFailed(true)}
        />
      ) : (
        <span className="tenant-logo__placeholder">{initial}</span>
      )}
    </span>
  );
}
